const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;
const USER_ID_COOKIE = 'poll_user_id';
const VOTES_COOKIE = 'poll_votes';

const readCookie = (name) => {
  if (typeof document === 'undefined') return null;
  const target = `${name}=`;
  const parts = document.cookie ? document.cookie.split('; ') : [];
  for (const part of parts) {
    if (part.startsWith(target)) {
      return decodeURIComponent(part.slice(target.length));
    }
  }
  return null;
};

const writeCookie = (name, value, maxAgeSeconds = ONE_YEAR_SECONDS) => {
  if (typeof document === 'undefined') return;
  const encoded = encodeURIComponent(value);
  document.cookie = `${name}=${encoded}; Max-Age=${maxAgeSeconds}; Path=/; SameSite=Lax`;
};

export const getOrCreatePollUserId = () => {
  const existing = readCookie(USER_ID_COOKIE);
  if (existing) return existing;
  const id = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
  writeCookie(USER_ID_COOKIE, id);
  return id;
};

export const getVotes = () => {
  const raw = readCookie(VOTES_COOKIE);
  if (!raw) return {};
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
};

export const setVote = (pollId, optionId) => {
  const votes = getVotes();
  votes[pollId] = optionId;
  writeCookie(VOTES_COOKIE, JSON.stringify(votes));
  return votes;
};

export const clearVote = (pollId) => {
  const votes = getVotes();
  delete votes[pollId];
  writeCookie(VOTES_COOKIE, JSON.stringify(votes));
  return votes;
};
